import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ShopFabric = ({ fabrics, selectedFabrics, onFabricChange }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleFabricChange = (event, fabric) => {
    // "All" button resets all selections
    if (fabric === '') {
      onFabricChange([]);
      return;
    }

    let updatedFabrics = [...(selectedFabrics || [])];

    if (event.target.checked) {
      if (!updatedFabrics.includes(fabric)) {
        updatedFabrics.push(fabric);
      }
    } else {
      updatedFabrics = updatedFabrics.filter((item) => item !== fabric);
    }

    onFabricChange(updatedFabrics);
  };

  // fabrics can be array of strings OR array of {code, count}
  const normalizedFabrics = (fabrics || []).map((f) =>
    typeof f === 'string' ? { code: f, count: null } : f
  );

  return (
    <div className="sidebar-widget">
      <h4
        className="pro-sidebar-title"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {t('Fabric')}
        <span style={{ fontSize: '12px' }}>{isOpen ? '▲' : '▼'}</span>
      </h4>
      {isOpen && (
        <div className="sidebar-widget-list mt-30">
        {fabrics && fabrics.length > 0 ? (
          <ul>
            <li>
              <label className="sidebar-widget-list-left">
                <input
                  type="checkbox"
                  className={selectedFabrics?.includes('') ? 'active' : ''}
                  onChange={(e) => handleFabricChange(e, '')}
                  checked={selectedFabrics?.length === 0}
                />
                <span className="checkmark" />
                <span className="checkmark-text">{t('All')}</span>
              </label>
            </li>
            {normalizedFabrics.map(({ code, count }, key) => {
              return (
                <li key={key}>
                  <label className="sidebar-widget-list-left">
                    <input
                      type="checkbox"
                      className={selectedFabrics?.includes(code) ? 'active' : ''}
                      onChange={(e) => handleFabricChange(e, code)}
                      checked={selectedFabrics?.includes(code)}
                    />
                    <span className="checkmark" />
                    <span className="checkmark-text">
                      {code}
                      {count !== null && (
                        <span style={{ color: 'var(--neutral-60)', marginLeft: 4, fontSize: '0.85em' }}>({count})</span>
                      )}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        ) : (
          <p>{t('No fabrics found')}</p>
        )}
        </div>
      )}
    </div>
  );
};

ShopFabric.propTypes = {
  fabrics: PropTypes.array,
  onFabricChange: PropTypes.func,
  selectedFabrics: PropTypes.array,
};

export default ShopFabric;
